import React, { useEffect, useState } from "react";
import {
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  InputNumber,
  Row,
  Col,
  Space,
  DatePicker,
  Radio,
  Upload,
  Image,
  notification,
  Popconfirm,
  Divider,
  Select,
  message,
  Tag,
} from "antd";

import { Columns } from "./columns";

import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import { convertTimestampToDate } from "utility/functions/convertTimestamp";

import {
  apiGetTickets,
  apiGetTicketDetail,
  apiDeleteTickets,
  apiSendPr,
  apiGetTax,
  apiCreateTicketPolicy,
  apiGetTicketPolicy,
  apiDeleteTicketPolicy,
  apiGetEventContent,
  apiCopyTicket,
} from "api/api";
import axios from "axios";

import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { convertTimeStamp } from "utility/functions/convertTimestamp";
import PrModal from "./PrModal";
import CreateAfterSaleModal from "./CreateAfterSaleModal";
import EditAfterSaleModal from "./EditAfterSaleModal";

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(utc);
dayjs.extend(timezone);

const TicketsSetting = () => {
  const id = sessionStorage.target_id;
  const [api, contextHolder] = notification.useNotification();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [record, setRecord] = useState({});
  // # 圖片預覽
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [fileList, setFileList] = useState(record.images);

  const [isTableLoading, setIsTableLoading] = useState(false);

  // # 標格顯示相關
  const [dataSource, setDataSource] = useState([]);
  const [total, setTotal] = useState(0);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [isCreateLoading, setIsCreateLoading] = useState(false);
  const [isUpdateLoading, setIsUpdateLoading] = useState(false);
  const [isPrLoading, setIsPrLoading] = useState(false);
  const [isAfterSaleLoading, setIsAfterSaleLoading] = useState(false);

  // # 稅務選項
  const [taxOptions, setTaxOptions] = useState([]);

  // # 公關票彈窗
  const [isVipOpen, setIsVipOpen] = useState(false);
  // # 公關票id
  const [prSourceId, setPrSourceId] = useState(0);

  // # 判斷是否是編輯模式
  const [isEditMode, setIsEditMode] = useState(false);
  const [isCreateAfterSaleOpen, setIsCreateAfterSaleOpen] = useState(false);
  const [isEditAfterSaleOpen, setIsEditAfterSaleOpen] = useState(false);

  // # 換票資料
  const [isLoading, setIsLoading] = useState(false);
  const [policyData, setPolicyData] = useState({});

  // # 活動時區
  const [eventTimezone, setEventTimezone] = useState("Asia/Taipei");

  const [form] = Form.useForm();
  const { RangePicker } = DatePicker;
  const requireMsg = "此欄位必填!";
  const TICKET_TYPE_EXTERNAL = 16;

  const genderOptions = [
    { value: 1, label: "男" },
    { value: 2, label: "女" },
    { value: 3, label: "其他" },
  ];

  // # 獲取資料
  const fetchData = async () => {
    setIsTableLoading(true);
    try {
      const res = await apiGetTickets({
        id,
        offset: current * pageSize - pageSize,
        limit: pageSize,
      });
      setDataSource([
        ...res.data.content.map((item) => ({
          ...item,
          isCopyBtnLoading: false,
        })),
      ]);
      setTotal(res.data.paging.count);
    } catch (error) {
      console.log("errr", error);
    } finally {
      setIsTableLoading(false);
    }
  };

  // # 獲取換票資料
  const fetchTicketPolicy = async (id) => {
    setIsLoading(true);
    try {
      const res = await apiGetTicketPolicy({ id });
      setPolicyData(res.data?.content);
    } catch (error) {
      message.error("獲取票券政策失敗");
    } finally {
      setIsLoading(false);
    }
  };

  // # 表格變化
  const onTableChange = (pagination) => {
    setCurrent(pagination.current);
  };

  // # 變更每頁顯示數量
  const onShowSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
  };

  useEffect(() => {
    fetchData();
  }, [current, pageSize]);

  // # 獲取稅務選項
  const fetchTax = async () => {
    try {
      const res = await apiGetTax();
      res.data.content.map((item) => {
        item.label = item.name;
        item.value = item.id;
      });
      setTaxOptions(res.data.content);
    } catch (error) {
      console.log("error", error);
    }
  };

  // # 獲取活動資訊（包含時區）
  const fetchEventInfo = async () => {
    try {
      const res = await apiGetEventContent({ id });
      const { content } = res.data;
      if (content.timezone) {
        setEventTimezone(content.timezone);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    fetchTax();
    fetchEventInfo();
    fetchData();
    console.log("重來");
  }, []);

  // * 彈窗
  const showModal = () => {
    form.resetFields();
    setFileList([]);
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setFileList([]);
    setRecord({});
    form.resetFields();
    setIsModalOpen(false);
  };

  // # 開關彈窗時，刪除資料
  // useEffect(() => {
  //   if (!isModalOpen) {
  //     setFileList([]);
  //     setRecord({});
  //     form.resetFields();
  //   }
  // }, [isModalOpen]);

  // * 提交表單
  const onFinish = (values) => {
    console.log("Success:", values);
    if (isEditMode) setIsUpdateLoading(true);
    else setIsCreateLoading(true);
    handleUpdate(values);
  };

  // # 更新 (新增 & 編輯共用)
  const handleUpdate = async (values) => {
    setIsTableLoading(true);
    const {
      sellDateTime,
      effectiveDateTime,
      admissionDateTime,
      startDateTime,
      title,
      remainQuantity,
      price,
      introduction,
      status,
      type,
      externalUrl,
      taxId,
      originalQuantity,
    } = values;
    const token = sessionStorage.t;
    const coverFile =
      fileList?.[0]?.originFileObj || fileList?.[0]?.file || null;
    let bodyFormData = new FormData();
    bodyFormData.append("title", title);
    bodyFormData.append("quantity", originalQuantity);
    bodyFormData.append("price", price);
    bodyFormData.append("introduction", introduction);
    bodyFormData.append("status", status);
    bodyFormData.append("type", type);
    bodyFormData.append(
      "externalUrl",
      Number(type) === TICKET_TYPE_EXTERNAL ? externalUrl?.trim() || "" : ""
    );
    bodyFormData.append("taxId", taxId);
    if (coverFile) {
      bodyFormData.append("cover", coverFile);
    }
    if (sellDateTime) {
      bodyFormData.append(
        "SaleStartDateTime",
        dayjs.tz(sellDateTime[0]?.$d, eventTimezone).utc().unix()
      );
      bodyFormData.append(
        "SaleEndDateTime",
        dayjs.tz(sellDateTime[1]?.$d, eventTimezone).utc().unix()
      );
    }
    if (effectiveDateTime) {
      bodyFormData.append(
        "EffectiveStartDateTime",
        dayjs.tz(effectiveDateTime[0]?.$d, eventTimezone).utc().unix()
      );
      bodyFormData.append(
        "EffectiveEndDateTime",
        dayjs.tz(effectiveDateTime[1]?.$d, eventTimezone).utc().unix()
      );
    }
    if (admissionDateTime) {
      bodyFormData.append(
        "AdmissionStartDateTime",
        dayjs.tz(admissionDateTime[0]?.$d, eventTimezone).utc().unix()
      );
      bodyFormData.append(
        "AdmissionEndDateTime",
        dayjs.tz(admissionDateTime[1]?.$d, eventTimezone).utc().unix()
      );
    }
    if (startDateTime) {
      bodyFormData.append(
        "StartDateTime",
        dayjs.tz(startDateTime[0]?.$d, eventTimezone).utc().unix()
      );
      bodyFormData.append(
        "EndDateTime",
        dayjs.tz(startDateTime[1]?.$d, eventTimezone).utc().unix()
      );
    }

    let url = isEditMode
      ? `${process.env.REACT_APP_API_URL}/Activity/${id}/Ticket/${record.id}`
      : `${process.env.REACT_APP_API_URL}/Activity/${id}/Ticket`;

    try {
      let res;
      if (isEditMode) {
        res = await axios.put(url, bodyFormData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      } else {
        res = await axios.post(url, bodyFormData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      }

      api.success({
        message: `更新成功`,
        introduction: `${res.data.message}`,
      });
      form.resetFields();
      setIsModalOpen(false);
      setRecord({});
      setFileList([]);
      setTimeout(() => {
        fetchData();
      }, [500]);
    } catch (error) {
      api.error({
        message: "原始數量不可少於剩餘數量",
        introduction: "",
      });
      setTimeout(() => {
        fetchData();
      }, 500);
    } finally {
      if (isEditMode) setIsUpdateLoading(false);
      else setIsCreateLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const getTicketDateValue = (timestamp) => {
    if (timestamp === undefined || timestamp === null) return null;

    const date = dayjs(
      convertTimeStamp(timestamp, "YYYY-MM-DD HH:mm", eventTimezone)
    );

    if (!date.isValid() || date.year() <= 2001) {
      return null;
    }

    return date;
  };

  const getDateRangeOrToday = (startTimestamp, endTimestamp) => {
    const startDate = getTicketDateValue(startTimestamp);
    const endDate = getTicketDateValue(endTimestamp);

    if (startDate && endDate) {
      return [startDate, endDate];
    }

    const today = dayjs().tz(eventTimezone).startOf("day");
    return [today, today];
  };

  // * 表格操作 / 顯示
  const handleEdit = async (row) => {
    setIsTableLoading(true);
    let ticket = row;

    try {
      const res = await apiGetTicketDetail({ id, ticketId: row.id });
      ticket = res.data?.content || row;
    } catch (error) {
      message.error("獲取票券資料失敗");
    } finally {
      setIsTableLoading(false);
    }

    const nextRecord = {
      ...ticket,
      sellDateTime: getDateRangeOrToday(
        ticket?.saleStartDateTime,
        ticket?.saleEndDateTime
      ),
      effectiveDateTime: getDateRangeOrToday(
        ticket?.effectiveStartDateTime,
        ticket?.effectiveEndDateTime
      ),
      admissionDateTime: getDateRangeOrToday(
        ticket?.admissionStartDateTime,
        ticket?.admissionEndDateTime
      ),
      startDateTime: getDateRangeOrToday(
        ticket?.startDateTime,
        ticket?.endDateTime
      ),
    };

    setFileList(
      ticket?.cover
        ? [
            {
              uid: String(ticket.id || ticket.cover),
              name: "cover",
              status: "done",
              url: `${ticket.cover}${
                ticket.cover.includes("?") ? "&" : "?"
              }t=${Date.now()}`,
            },
          ]
        : []
    );

    setRecord(nextRecord);
    form.setFieldsValue(nextRecord);
    setTimeout(() => {
      setIsModalOpen(true);
    }, 500);
  };

  // # 刪除列表
  const handleDelete = async (record) => {
    setIsTableLoading(true);

    try {
      const res = await apiDeleteTickets({ id, ticketId: record.id });
      api.success({
        message: `刪除成功`,
        introduction: `${res.data.message}`,
      });
      setTimeout(() => {
        fetchData();
      }, [500]);
    } catch (err) {
      api.error({
        message: `刪除失敗`,
        introduction: "",
      });
      setTimeout(() => {
        fetchData();
      }, 500);
    } finally {
      setIsTableLoading(false);
    }
  };

  // # 改變datasource 中的loading 狀態
  const changeLoading = (targetId, key, isLoading) => {
    setDataSource((prev) =>
      prev.map((item) =>
        item.id === targetId ? { ...item, [key]: isLoading } : item
      )
    );
  };

  // # 複製票券
  const handleCopy = async (record) => {
    changeLoading(record.id, "isCopyBtnLoading", true);
    setIsTableLoading(true);

    try {
      const res = await apiCopyTicket({ id, ticketId: record.id });
      api.success({
        message: `複製成功`,
        introduction: `${res.data?.message || ""}`,
      });
      fetchData();
    } catch (err) {
      api.error({
        message: `複製失敗`,
        introduction: err?.response?.data?.message || "",
      });
    } finally {
      changeLoading(record.id, "isCopyBtnLoading", false);
      setIsTableLoading(false);
    }
  };

  // # 觀察 record 決定現在是編輯模式還是新建模式
  useEffect(() => {
    if (Object.keys(record).length == 0) setIsEditMode(false);
    else {
      setIsEditMode(true);
    }
  }, [record]);

  // # 封面圖片更新時
  const coverProps = {
    accept: ".gif,.jpg,.png",
    name: "image",
    withCredentials: true,
    listType: "picture-card",
    maxCount: 1,
    beforeUpload: (file) => {
      const url = URL.createObjectURL(file);
      setFileList([
        {
          uid: file.uid,
          name: file.name,
          status: "done",
          url,
          originFileObj: file,
        },
      ]);
      return false;
    },
    onChange({ fileList: newFileList }) {
      const latestFile = newFileList.slice(-1)[0];
      if (!latestFile) {
        setFileList([]);
      } else {
        setFileList([
          {
            ...latestFile,
            status: latestFile.status || "done",
            url:
              latestFile.url ||
              latestFile.thumbUrl ||
              (latestFile.originFileObj
                ? URL.createObjectURL(latestFile.originFileObj)
                : undefined),
          },
        ]);
      }
      form.validateFields(["cover"]).catch(() => {});
    },
  };

  // # 圖片預覽
  const handlePreview = async (file) => {
    setPreviewImage(file.url || file.preview || file.thumbUrl);
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
  };

  // # 開啟
  const onVipTicketOpen = (record) => {
    setIsVipOpen(true);
    setPrSourceId(record.id);
  };

  // # submit 公關票
  const handleTicketSend = (value) => {
    console.log("傳出", value);
    setIsPrLoading(true);
    // # api
    fetchSendPr(value);
  };

  // # 公關票 api
  const fetchSendPr = async (value) => {
    let data = { ...value, sourceId: prSourceId };
    console.log(data);
    try {
      const res = await apiSendPr(data);
      setIsPrLoading(false);
      message.success("公關票發送成功");
      setIsVipOpen(false);
    } catch (error) {
      message.error(error.response.data.message);
      setIsPrLoading(false);
    }
  };

  const handleAfterSaleSubmit = async (values) => {
    // 分解 switchDateTimeRange 和 refundDateTimeRange
    const [switchStartDateTime, switchEndDateTime] =
      values.switchDateTimeRange || [];
    const [refundStartDateTime, refundEndDateTime] =
      values.refundDateTimeRange || [];

    const { id, refundDateTimeRange, switchDateTimeRange, ...restValues } =
      values; // 移除 id,refundDateTimeRange,switchDateTimeRange

    const payload = {
      ...restValues,
      sourceId: id, // 新增 sourceId 並接 id 的值
      switchStartDateTime: switchStartDateTime
        ? dayjs.tz(switchStartDateTime.$d, eventTimezone).utc().unix()
        : null,
      switchEndDateTime: switchEndDateTime
        ? dayjs.tz(switchEndDateTime.$d, eventTimezone).utc().unix()
        : null,
      refundStartDateTime: refundStartDateTime
        ? dayjs.tz(refundStartDateTime.$d, eventTimezone).utc().unix()
        : null,
      refundEndDateTime: refundEndDateTime
        ? dayjs.tz(refundEndDateTime.$d, eventTimezone).utc().unix()
        : null,
    };

    setIsAfterSaleLoading(true);
    try {
      const res = await apiCreateTicketPolicy({ data: payload });
      message.success("售後退換票設定成功");
      fetchData();
    } catch (error) {
      message.error(error.response.data.message);
    } finally {
      setIsAfterSaleLoading(false);
      setIsCreateAfterSaleOpen(false);
    }
  };

  const onCreateAfterSaleOpen = (record) => {
    setRecord(record);
    setIsCreateAfterSaleOpen(true);
  };

  // # 刪除售後退換票設定
  const handleDeletePolicy = async (policyId) => {
    setIsLoading(true);
    try {
      await apiDeleteTicketPolicy({ id: policyId });
      message.success("刪除成功");
      fetchData();
    } catch (error) {
      message.error("刪除失敗");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="w-full">
      {contextHolder}
      <h2 className="text-Gray-8 mb-0">票券設定</h2>
      <p className="m-0 text-Gray-5">設定你的活動基本資訊。</p>
      <Card
        title={<h3 className="text-left">新增的活動票券</h3>}
        className="text-center mt-5 rounded-3xl px-0 pt-6 min-h-[calc(100vh-250px)]"
        extra={
          <Button type="primary" onClick={showModal}>
            新增
          </Button>
        }
      >
        <Table
          columns={Columns({
            handleEdit,
            handleDelete,
            handleCopy,
            taxOptions,
            onCreateAfterSaleOpen,
            onVipTicketOpen,
          })}
          dataSource={dataSource}
          loading={isTableLoading}
          onChange={onTableChange}
          pagination={{
            total,
            current,
            pageSize,
            showSizeChanger: true,
            onShowSizeChange,
          }}
          expandable={{
            columnTitle: "換票詳情",
            expandedRowRender: (record) => (
              <div className="flex flex-col">
                <Space className="pl-28">
                  {policyData?.enableRefundPolicy && (
                    <Tag color="cyan">開放退票</Tag>
                  )}
                  {policyData?.enableSwitchPolicy && (
                    <Tag color="cyan">開放換票</Tag>
                  )}
                  {policyData?.switchRangeType === 1 ? (
                    <Tag color="cyan">僅限本場活動</Tag>
                  ) : (
                    <Tag color="cyan">開放跨活動</Tag>
                  )}
                  {policyData?.refundStartDateTime &&
                    policyData?.refundEndDateTime && (
                      <Tag color="cyan">
                        可退票時間：
                        {convertTimestampToDate(
                          policyData?.refundStartDateTime
                        )}
                        ~{" "}
                        {convertTimestampToDate(policyData?.refundEndDateTime)}
                      </Tag>
                    )}
                  {policyData?.switchStartDateTime &&
                    policyData?.switchEndDateTime && (
                      <Tag color="cyan">
                        可換票時間:
                        {convertTimestampToDate(
                          policyData?.switchStartDateTime
                        )}
                        ~{convertTimestampToDate(policyData?.switchEndDateTime)}
                      </Tag>
                    )}

                  <Space>
                    <Button
                      color="primary"
                      size="small"
                      variant="outlined"
                      onClick={() => setIsEditAfterSaleOpen(true)}
                    >
                      編輯
                    </Button>
                    <Popconfirm
                      title="確定要刪除這項設定嗎？"
                      onConfirm={() => handleDeletePolicy(policyData?.id)}
                      okText="是"
                      cancelText="否"
                    >
                      <Button
                        color="primary"
                        variant="outlined"
                        danger
                        size="small"
                      >
                        刪除
                      </Button>
                    </Popconfirm>
                  </Space>
                </Space>
              </div>
            ),
            onExpand: (expanded, record) => {
              if (expanded) {
                fetchTicketPolicy(record.afterSalePolicyId);
              }
            },
            rowExpandable: (record) => !!record.afterSalePolicyId,
            expandIcon: ({ expanded, onExpand, record, expandable }) => {
              if (!expandable) return <span>-</span>;
              return (
                <button
                  type="button"
                  className={`ant-table-row-expand-icon ${
                    expanded
                      ? "ant-table-row-expand-icon-expanded"
                      : "ant-table-row-expand-icon-collapsed"
                  }`}
                  aria-label={expanded ? "Collapse row" : "Expand row"}
                  onClick={(e) => {
                    e.stopPropagation();
                    onExpand(record, e);
                  }}
                />
              );
            },
          }}
          rowKey={(record) => record.id}
          scroll={{ x: "max-content" }}
        />
      </Card>
      <Modal
        title={isEditMode ? "編輯" : "新增"}
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        destroyOnClose={true}
        width={800}
      >
        <Form
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          // layout="vertical"
          variant="filled"
          size="large"
          form={form}
          preserve={false}
          scrollToFirstError={true}
          initialValues={isEditMode ? record : null}
          labelCol={{ span: 3 }}
        >
          <Form.Item
            name="cover"
            label="上傳封面"
            required
            rules={[
              {
                validator: async () => {
                  if (fileList?.length > 0) {
                    return Promise.resolve();
                  }

                  return Promise.reject(new Error(requireMsg));
                },
              },
            ]}
          >
            <Upload
              {...coverProps}
              fileList={fileList}
              onPreview={handlePreview}
              className="w-full [&_.ant-upload-list-item-container]:grow [&_.ant-upload.ant-upload-select]:grow "
            >
              {fileList?.length >= 1 ? null : (
                <button style={{ border: 0, background: "none" }} type="button">
                  <PlusOutlined />
                  <div style={{ marginTop: 8 }}>上傳圖片</div>
                </button>
              )}
            </Upload>
          </Form.Item>
          <Form.Item
            name="title"
            label="票券名稱"
            rules={[
              {
                required: true,
                message: requireMsg,
              },
            ]}
          >
            <Input placeholder="請輸入票券名稱" />
          </Form.Item>
          <Form.Item
            name="originalQuantity"
            label="原始數量"
            rules={[
              {
                required: true,
                message: requireMsg,
              },
            ]}
          >
            <InputNumber
              className="w-full"
              placeholder="請輸入票券數量"
              min={0}
            />
          </Form.Item>
          {/* <Form.Item name="remainQuantity" label="剩餘數量">
            <InputNumber
              className="w-full"
              placeholder="請輸入票券數量"
              min={0}
            />
          </Form.Item> */}
          <Form.Item
            name="price"
            label="票價"
            rules={[
              {
                required: true,
                message: requireMsg,
              },
            ]}
          >
            <InputNumber className="w-full" placeholder="請輸入票價" min={0} />
          </Form.Item>
          <Form.Item
            name="introduction"
            label="票券說明"
            rules={[
              {
                required: true,
                message: requireMsg,
              },
            ]}
          >
            <Input.TextArea autoSize={{ minRows: 5 }}></Input.TextArea>
          </Form.Item>
          <Form.Item
            name="taxId"
            label="稅務選項"
            rules={[
              {
                required: true,
                message: requireMsg,
              },
            ]}
          >
            <Select options={taxOptions}></Select>
          </Form.Item>
          <Form.Item name="sellDateTime" label="售票時間">
            <RangePicker
              className="w-full"
              showTime={{
                format: "HH:mm",
              }}
              format="YYYY-MM-DD HH:mm"
            ></RangePicker>
          </Form.Item>
          <Form.Item name="admissionDateTime" label="入場時間">
            <RangePicker
              className="w-full"
              showTime={{
                format: "HH:mm",
              }}
              format="YYYY-MM-DD HH:mm"
            ></RangePicker>
          </Form.Item>
          <Form.Item name="effectiveDateTime" label="報到時間">
            <RangePicker
              className="w-full"
              showTime={{
                format: "HH:mm",
              }}
              format="YYYY-MM-DD HH:mm"
            ></RangePicker>
          </Form.Item>
          <Form.Item name="startDateTime" label="開始時間">
            <RangePicker
              className="w-full"
              showTime={{
                format: "HH:mm",
              }}
              format="YYYY-MM-DD HH:mm"
            ></RangePicker>
          </Form.Item>
          <Form.Item
            name="type"
            label="票券類型"
            rules={[
              {
                required: true,
                message: requireMsg,
              },
            ]}
          >
            <Radio.Group>
              <Radio value={0}>不設定</Radio>
              <Radio value={1}>付費票</Radio>
              <Radio value={2}>公關票</Radio>
              <Radio value={16}>外部連結</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.type !== currentValues.type
            }
          >
            {({ getFieldValue }) =>
              Number(getFieldValue("type")) === TICKET_TYPE_EXTERNAL ? (
                <Form.Item
                  name="externalUrl"
                  label="外部連結"
                  rules={[
                    {
                      required: true,
                      message: requireMsg,
                    },
                    {
                      type: "url",
                      message: "請輸入有效網址",
                    },
                  ]}
                >
                  <Input placeholder="請輸入外部連結網址" />
                </Form.Item>
              ) : null
            }
          </Form.Item>
          <Form.Item
            name="status"
            label="是否開賣"
            rules={[
              {
                required: true,
                message: requireMsg,
              },
            ]}
          >
            <Radio.Group>
              <Radio value={0}>不設定</Radio>
              <Radio value={1}>販售</Radio>
              <Radio value={2}>售完</Radio>
              <Radio value={4}>免費票</Radio>
              <Radio value={8}>停售</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item className="text-right">
            <Space>
              <Button type="default" onClick={() => handleCancel()}>
                取消
              </Button>
              <Button
                htmlType="submit"
                type="primary"
                loading={isEditMode ? isUpdateLoading : isCreateLoading}
              >
                {isEditMode ? "更新" : "建立"}
              </Button>
            </Space>
          </Form.Item>
        </Form>
        {previewImage && (
          <Image
            wrapperStyle={{
              display: "none",
            }}
            preview={{
              visible: previewOpen,
              onVisibleChange: (visible) => setPreviewOpen(visible),
              afterOpenChange: (visible) => !visible && setPreviewImage(""),
            }}
            src={previewImage}
          />
        )}
      </Modal>
      <PrModal
        isVipOpen={isVipOpen}
        setIsVipOpen={setIsVipOpen}
        handleTicketSend={handleTicketSend}
        genderOptions={genderOptions}
        isPrLoading={isPrLoading}
      />
      <CreateAfterSaleModal
        isCreateAfterSaleOpen={isCreateAfterSaleOpen}
        setIsCreateAfterSaleOpen={setIsCreateAfterSaleOpen}
        handleAfterSaleSubmit={handleAfterSaleSubmit}
        isAfterSaleLoading={isAfterSaleLoading}
        record={record}
        eventTimezone={eventTimezone}
      />
      <EditAfterSaleModal
        isEditAfterSaleOpen={isEditAfterSaleOpen}
        setIsEditAfterSaleOpen={setIsEditAfterSaleOpen}
        policyData={policyData}
        setPolicyData={setPolicyData}
        fetchData={fetchData}
        eventTimezone={eventTimezone}
      />
    </div>
  );
};

export default TicketsSetting;
